import { FC } from "react";
import ModalComponent from "../../shared/base-components/Modal";

import { Col, Row, Table } from "reactstrap";
import { StaffDetailModalProps } from "./Staff.constants";
import { formatDateString } from "../../shared/utils/formatText";

const StaffDetailModal: FC<StaffDetailModalProps> = ({
  userData,
  isModalOpen,
  toggle,
}) => {
  return (
    <ModalComponent
      header={"Müşteri Bilgileri"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Row>
        <Col lg={12}>
          <div className="border rounded">
            <div className="table-responsive">
              <Table className="table-nowrap align-middle mb-0">
                <tbody>
                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Tam ad:"}</h5>

                    <td className="text-start">{userData?.fullname}</td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Kullanıcı adı:"}</h5>

                    <td style={{ whiteSpace: "normal" }} className="text-start">
                      {userData?.username}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Email:"}</h5>

                    <td className="text-start">{userData?.email}</td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Telefon:"}</h5>

                    <td className="text-start">
                      {userData?.phone_number || "Yok"}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Net Maaş:"}</h5>

                    <td className="text-start">{userData?.salary_net} ₺</td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Brüt:"}</h5>

                    <td className="text-start">{userData?.salary_gross} ₺</td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Konum Takip:"}</h5>

                    <td className="text-start">
                      {userData?.can_follow ? "Var" : "Yok"}{" "}
                    </td>
                  </tr>

                  <tr key={"key"}>
                    <h5 className="font-size-15 mb-1">{"Başlama Tarihi:"}</h5>

                    <td className="text-start">
                      {formatDateString(
                        userData?.date_of_start.toString() || ""
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </Row>
    </ModalComponent>
  );
};

export default StaffDetailModal;
